export default (function removeEvent(eventGroup, index) {
  if (!isNaN(index)) {
    eventGroup.events.splice(index, 1);
  } else {
    return new Error("Index of event must be a number.");
  }
  return eventGroup;
});